import DietPage from "./pages/DietPage";
import EntryPollAdmin from "./pages/EntryPollAdmin";
import EntryPollUser from "./pages/EntryPollUser";
import Home from "./pages/Home";
import Patient from "./pages/Patient";
import ProgramRoutinePage from "./pages/ProgramRoutinePage";
import Router from "vue-router";
import store from "./store/";
import Vue from "vue";

Vue.use(Router);

const isAuthenticated = (to, from, next) => {
  if (store.state.login.token) {
    next();
  } else {
    next("/");
  }
};

export default new Router({
  routes: [
    { path: "", component: Home, name: "home" },
    {
      path: "/patient/:id",
      component: Patient,
      name: "patient",
      beforeEnter: isAuthenticated
    },
    { 
      path: "/poll/:id", 
      component: EntryPollUser, 
      name: "entry_poll_user" },
    { 
      path: "/poll/:id/review", 
      component: EntryPollAdmin, 
      name: "entry_poll_admin",
      beforeEnter: isAuthenticated
    },
    {
      path: "/program/:id",
      component: ProgramRoutinePage,
      name: "program",
      beforeEnter: isAuthenticated
    },
    {
      path: "/diet/:id",
      component: DietPage,
      name: "diet",
      beforeEnter: isAuthenticated
    }
  ]
});
